module.exports = __webpack_public_path__ + "img/products-banner.bd0261cf.jpg";